export class PaymentProviderConfigRequestModel {
  constructor(public cinemaId: string, public orderId: string, public paymentProviderIdentifier: string, public paymentChannel?: string) {}
}
